<div class="match-result-row position-relative d-flex align-items-start gap-3" [class.selected]="isSelected()"
     *transloco="let t; prefix: 'match-series-result-item'"
     (click)="selectItem()">

  @if (isSelected()) {
    <div class="selected-check position-absolute d-flex align-items-center justify-content-center rounded-circle" aria-hidden="true">
      <i class="fa-solid fa-check"></i>
    </div>
    <span class="visually-hidden">{{ t('selected-alt') }}</span>
  }

  <app-image [imageUrl]="item().series.coverUrl ?? ''" width="72px" height="102px" />

  <div class="match-result-content d-flex flex-column flex-fill gap-1">

    <div class="match-result-title-row d-flex align-items-center flex-wrap gap-2">
      <h3 class="match-result-name fw-bold">
        <a [href]="item().series.siteUrl | safeUrl" target="_blank" rel="noreferrer noopener">{{ item().series.name }}</a>

      </h3>
      <app-media-format-pill [format]="item().series.plusMediaFormat" />
    </div>

    <div class="match-result-meta d-flex align-items-center flex-wrap">
      <app-match-status-dot [endDate]="item().series.endDate" />
      @if (startYear()) {
        <span class="dot-separator mx-1" aria-hidden="true"></span>
        <span>{{ startYear() }}{{ endYear() && endYear() !== startYear() ? '–' + endYear() : '' }}</span>
      }
      @if (firstAuthor()) {
        <span class="dot-separator mx-1" aria-hidden="true"></span>
        <span>{{ firstAuthor() }}</span>
      }
      @if ((item().series.volumes ?? 0) > 0 || (item().series.chapters ?? 0) > 0) {
        <span class="dot-separator mx-1" aria-hidden="true"></span>
        <span>
          @if ((item().series.volumes ?? 0) > 0) {
            {{ t('volume-count', {num: item().series.volumes}) }}
          }
          @if ((item().series.chapters ?? 0) > 0) {
            {{ t('chapter-count', {num: item().series.chapters}) }}
          }
        </span>
      }
    </div>

    <div class="match-result-providers d-flex align-items-center flex-wrap gap-1">
      @if (item().series.mangabakaId) {
        <app-scrobble-provider-tag-badge [provider]="ScrobbleProvider.MangaBaka" [id]="item().series.mangabakaId" />
      }
      @if (item().series.aniListId) {
        <app-scrobble-provider-tag-badge [provider]="ScrobbleProvider.AniList" [id]="item().series.aniListId" />
      }
      @if (item().series.malId) {
        <app-scrobble-provider-tag-badge [provider]="ScrobbleProvider.Mal" [id]="item().series.malId" />
      }
      @if (item().series.hardcoverId) {
        <app-scrobble-provider-tag-badge [provider]="ScrobbleProvider.Hardcover" [id]="item().series.hardcoverId" [isStandAlone]="item().series.isStandAlone" />
      }
    </div>

    @if (showSynonyms() && displaySynonyms().length > 0) {
      <div class="match-result-synonyms d-flex align-items-center flex-wrap gap-1">
        <i class="fa-solid fa-language" aria-hidden="true"></i>
        <span>{{ t('alt-titles') }}</span>
        <span class="synonym-first">"{{ displaySynonyms()[0] }}"</span>
        @if (displaySynonyms().length > 1) {
          <span class="synonym-more d-inline-flex align-items-center rounded-pill fw-semibold"
                [ngbTooltip]="synonymTooltip"
                tooltipClass="series-synonym-tooltip"
                placement="top"
                autoClose="false"
                (click)="$event.stopPropagation()">
            {{ t('more-titles', {count: displaySynonyms().length - 1}) }}
          </span>
          <ng-template #synonymTooltip>
            <ul class="list-unstyled mb-0">
              @for (s of displaySynonyms(); track s) {
                <li>"{{ s }}"</li>
              }
            </ul>
          </ng-template>
        }
      </div>
    }

    <div class="match-result-synopsis">{{ item().series.summary }}</div>

    @if (item().series.editions.length > 0) {
      <div class="match-result-editions d-flex flex-row flex-wrap gap-1">
        @for (edition of item().series.editions; track edition.id) {
          <button type="button"
                  class="edition-chip d-flex flex-column flex-md-row align-items-center justify-content-md-between gap-1 gap-md-2"
                  [class.selected]="isEditionSelected(edition)"
                  [attr.aria-pressed]="isEditionSelected(edition)"
                  (click)="chooseEdition(edition, $event)">
            <div class="d-flex align-items-center gap-1">
              @if (isEditionSelected(edition)) {
                <i class="fa-solid fa-check edition-chip-icon" aria-hidden="true"></i>
              }
              <span>{{ edition.title }}</span>
            </div>
            <div class="d-flex align-items-center gap-1">
              @if (edition.format) {
                <span class="edition-chip-format">{{ edition.format }}</span>
              }
              @if (edition.mainCount > 0) {
                <span class="edition-chip-count">{{ t('edition-main-count', {num: edition.mainCount}) }}</span>
              }
              @if (edition.totalCount - edition.mainCount > 0) {
                <span class="edition-chip-count edition-chip-extra">{{ t('edition-extra-count', {num: edition.totalCount - edition.mainCount}) }}</span>
              }
            </div>
          </button>
        }
      </div>
    }

  </div>

  <div class="match-result-rail d-flex flex-column flex-shrink-0 align-items-end">
    <app-confidence-chip [pct]="pct()" />
  </div>

</div>
